import { EmptyComponent } from "../common/EmptyComponent";
import Loadable from "react-loadable";

export const ModalWidget = Loadable({
  loader: () => import(/* webpackChunkName: "widget/modal" */ "./ModalWidget"),
  loading: EmptyComponent
});
